import './SectionLauncherButton.css';

import React from 'react';

interface SectionLauncherButtonProps {
  label: string;
  scoredCount: number;
  scorableCount: number;
  isGeneralComments?: boolean;
  onClick: () => void;
  ariaLabel?: string;
}

const SectionLauncherButton: React.FC<SectionLauncherButtonProps> = ({
  label,
  scoredCount,
  scorableCount,
  isGeneralComments = false,
  onClick,
  ariaLabel,
}) => {
  const progressPercent = scorableCount > 0
    ? Math.round((scoredCount / scorableCount) * 100)
    : 0;
  const isComplete = scorableCount > 0 && scoredCount === scorableCount;
  const isInProgress = scorableCount > 0 && scoredCount > 0 && !isComplete;
  const stateClass = isComplete ? 'is-complete' : isInProgress ? 'is-in-progress' : '';

  return (
    <button
      type="button"
      className={`section-launcher-btn${stateClass ? ` ${stateClass}` : ''}`}
      onClick={onClick}
      aria-label={ariaLabel ?? `Open ${label} section`}
    >
      <div className="section-launcher-btn-accent" />
      <div className="section-launcher-btn-head">
        <span className="section-launcher-btn-label">{label}</span>
        <span className="section-launcher-btn-meta">
          {scorableCount > 0 ? (
            <span className="section-launcher-btn-count">
              {isGeneralComments ? scoredCount : `${scoredCount}/${scorableCount}`}
            </span>
          ) : null}
          <span className="section-launcher-btn-chevron" aria-hidden="true">›</span>
        </span>
      </div>
      {scorableCount > 0 && !isGeneralComments ? (
        <div className="section-launcher-btn-progress">
          <div
            className="section-launcher-btn-progress-fill"
            style={{ width: `${isGeneralComments ? 100 : progressPercent}%` }}
          />
        </div>
      ) : null}
    </button>
  );
};

export default SectionLauncherButton;
